import { MText } from "src/ui/MText"

export function ParadiseDetailsHeading({
  children,
}: {
  children: React.ReactNode
}) {
  return <MText variant="heading2">{children}</MText>
}
